import { render, staticRenderFns } from "./QuickDeclareStep1.vue?vue&type=template&id=7ed52873&"
import script from "./QuickDeclareStep1.vue?vue&type=script&lang=js&"
export * from "./QuickDeclareStep1.vue?vue&type=script&lang=js&"
import style0 from "./QuickDeclareStep1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports